/*
==========================================
Custom JS for Product page
==========================================
*/

// 数量セレクター ドロップダウン
// (標準のInputを非表示にし、ドロップダウン変更時に更新)
const changeQty = (e) => {
  const targetId = document.getElementById(e.target.dataset.target_id);
  targetId.value = e.target.value;
};

// 再入荷通知ボタン呼び出し
const callBIS = () => {
  document.getElementById("BIS_trigger").click();
};

// カートに追加ボタン (バリデーション用)
const validateBfSubmit = (e) => {
  const key = e.keyCode || e.charCode || 0;
  let submitFlg = false;

  // 13(Enter key) または カート追加ボタン押下時
  if (key == 13) {
    e.preventDefault();
    submitFlg = true;
  } else if (e.target.id === "c-submit-btn") {
    e.preventDefault();
    submitFlg = true;
  }

  if (submitFlg === true) {
    const inputElem = document.getElementById("input-name");
    let error_flg = false;
    if (inputElem) {
      inputElem.classList.remove("is-error");
      let regex = "";
      const inputValue = inputElem.value;
      switch (inputElem.dataset.input_type) {
        case "initial":
          regex = /^[A-Z]+$/;
          if (inputValue.length === 0) {
            alert("名入れ指定が入力されていません。");
            inputElem.classList.add("is-error");
            error_flg = true;
          } else if (inputValue.length > 1) {
            alert("名入れは1文字までで入力してください。");
            inputElem.classList.add("is-error");
            error_flg = true;
          } else if (regex.test(inputValue) !== true) {
            alert("名入れはアルファベットの大文字で入力してください。");
            inputElem.classList.add("is-error");
            error_flg = true;
          }
          break;
        case "alphabet":
          regex = /^[A-Z][a-z]*$/;
          if (inputValue.length === 0) {
            alert("名入れ指定が入力されていません。");
            inputElem.classList.add("is-error");
            error_flg = true;
          } else if (inputValue.length > 12) {
            alert("名入れは12文字までで入力してください。");
            inputElem.classList.add("is-error");
            error_flg = true;
          } else if (regex.test(inputValue) !== true) {
            alert(
              "名入れはアルファベットで頭文字のみ大文字、その他小文字で入力してください。"
            );
            inputElem.classList.add("is-error");
            error_flg = true;
          }
          break;
        case "kana":
          regex = /^[ぁ-ゞー　]*$/;
          if (inputValue.length === 0) {
            alert("名入れ指定が入力されていません。");
            inputElem.classList.add("is-error");
            error_flg = true;
          } else if (inputValue.length > 6) {
            alert("名入れは6文字までで入力してください。");
            inputElem.classList.add("is-error");
            error_flg = true;
          } else if (regex.test(inputValue) !== true) {
            alert("名入れはひらがなで入力してください。");
            inputElem.classList.add("is-error");
            error_flg = true;
          }
          break;
        case "helmet":
          const regex_kana = /^[ぁ-ゞー　]*$/;
          const regex_kanji = /^[一-龠]*$/;
          const regex_alphabet = /^[a-zA-Z.]*$/;

          // 文字種ごとの最大数
          let maxLength = 6;

          if (inputValue.length === 0) {
            alert("名入れ指定が入力されていません。");
            inputElem.classList.add("is-error");
            error_flg = true;
          }

          if (regex_kana.test(inputValue) === true) {
            // ひらがなのみ
            maxLength = 7;
          } else if (regex_kanji.test(inputValue) === true) {
            // 漢字のみ
            maxLength = 6;
          } else if (regex_alphabet.test(inputValue) === true) {
            // アルファベット+ドットのみ
            maxLength = 12;
          } else {
            // 混合はエラー
            alert(
              "名入れはひらがな、漢字、半角アルファベットのいずれか1種のみで入力してください。"
            );
            inputElem.classList.add("is-error");
            error_flg = true;
          }

          if (!error_flg) {
            if (inputValue.length > maxLength) {
              alert(
                `名入れは漢字(6文字まで)／ひらがな(7文字まで)／アルファベット(半角12文字まで)のいずれかで入力してください。`
              );
              inputElem.classList.add("is-error");
              error_flg = true;
            }
          }

          break;
      }
    }

    if (error_flg === false) {
      document.querySelector('.product-form__submit[name="add"]').click();
    }
  }
};

// 商品ギャラリー ポップアップスライドショー
const productGallerySlideshow = () => {
  // スライド内動画要素の一時停止と再生処理
  function playPauseVideo(slider) {
    let slides, video;
    slides = slider.querySelectorAll(".swiper-slide");
    slides.forEach(function (slide) {
      video = slide.querySelector("video");
      if (video) {
        if (slide.classList.contains("swiper-slide-active")) {
          video.play();
        } else {
          video.pause();
        }
      }
    });
  }

  // Swiper定義
  const swiper = new Swiper(".swiper", {
    // Optional parameters
    loop: false,
    lazy: true,
    speed: 800,
    runCallbacksOnInit: false,

    // Event
    on: {
      afterInit: function () {
        playPauseVideo(this.el);
      },
      slideChangeTransitionEnd: function () {
        playPauseVideo(this.el);
      },
    },

    pagination: {
      el: ".c-slideshow__pagination",
      type: "fraction",
      formatFractionCurrent: function (number) {
        if (number < 10) {
          return "0" + number;
        } else {
          return number;
        }
      },
      formatFractionTotal: function (number) {
        if (number < 10) {
          return "0" + number;
        } else {
          return number;
        }
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: ".slider-button--next",
      prevEl: ".slider-button--prev",
    },
  });

  // Thumbnail押下
  document.querySelectorAll(".product__media-toggle").forEach((elem, index) => {
    elem.addEventListener("click", () => {
      swiper.slideTo(index);
    });
  });
};
productGallerySlideshow();

// 動画再生ボタン
const handleProductVideoPlay = () => {
  const playWrapperEls = document.querySelectorAll("[data-js-play-wrapper]");
  Array.from(playWrapperEls).forEach((el) => {
    el.addEventListener("click", () => {
      el.nextElementSibling.play();
      el.style.display = "none";
    });
  });
};

// 商品ギャラリー(SP) 矢印ボタン押下時にメインスライドを切り替え
window.addEventListener("DOMContentLoaded", () => {
  const galleryBtnOnMobilePrev = document.getElementById(
      "galley-btn-on-mobile--prev"
    ),
    galleryBtnOnMobileNext = document.getElementById(
      "galley-btn-on-mobile--next"
    );

  // 初期表示時に前へボタンを非活性
  galleryBtnOnMobilePrev.setAttribute("disabled", true);

  // 前へボタンクリック
  galleryBtnOnMobilePrev.addEventListener("click", () => {
    const currentSlide = galleryBtnOnMobilePrev.parentNode.querySelector(
        '[aria-current="true"]'
      ),
      firstSlidePosition = Number(
        galleryBtnOnMobilePrev.parentNode
          .querySelector("[data-media-position]:first-child")
          .getAttribute("data-media-position")
      );
    const currentPosition = Number(
      currentSlide.parentNode.getAttribute("data-media-position")
    );

    if (currentPosition !== firstSlidePosition) {
      // 現在が最初スライドでなければ、隣のスライドをクリック
      const prevSlide = galleryBtnOnMobilePrev.parentNode.querySelector(
        `[data-media-position="${currentPosition - 1}"]`
      );
      prevSlide.querySelector("button").click();
    }
    // 活性制御 → global.js
  });

  // 次へボタンクリック
  galleryBtnOnMobileNext.addEventListener("click", () => {
    const currentSlide = galleryBtnOnMobileNext.parentNode.querySelector(
        '[aria-current="true"]'
      ),
      lastSlidePosition = Number(
        galleryBtnOnMobileNext.parentNode
          .querySelector("[data-media-position]:last-child")
          .getAttribute("data-media-position")
      );
    const currentPosition = Number(
      currentSlide.parentNode.getAttribute("data-media-position")
    );

    if (currentPosition !== lastSlidePosition) {
      // 現在が最終スライドでなければ、隣のスライドをクリック
      const nextSlide = galleryBtnOnMobileNext.parentNode.querySelector(
        `[data-media-position="${currentPosition + 1}"]`
      );
      nextSlide.querySelector("button").click();
    }
    // 活性制御 → global.js
  });

  // 動画再生ボタンのイベントセット
  handleProductVideoPlay();
});
